
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.VisualStudio.Services.ServiceEndpoints.WebApi
// Microsoft.Azure.DevOps.ServiceEndpoints.Sdk.Server
//----------------------------------------------------------


/// <amd-module name="ServiceEndpoints/Client/Constants/ServiceEndpoint" />
export module AzureEndpointConstants {
    export const TenantId = "tenantid";
    export const AppObjectId = "appObjectId";
    export const SpnObjectId = "spnObjectId";
    export const SpnCreationMode = "creationMode";
    export const AzureSubscriptionId = "subscriptionId";
    export const AzureSubscriptionName = "subscriptionName";
    export const ResourceGroupName = "resourceGroupName";
    export const AzureManagementGroupId = "managementGroupId";
    export const MlWorkspaceName = "mlWorkspaceName";
    export const MlWorkspaceId = "mlWorkspaceId";
    export const MlWorkspaceLocation = "mlWorkspaceLocation";
    export const AzureManagementGroupName = "managementGroupName";
    export const ManagementGroupString = "ManagementGroup";
    export const WorkspaceString = "AzureMLWorkspace";
    export const SubscriptionString = "Subscription";
    export const SpnCreationModeAutomatic = "Automatic";
    export const SpnCreationModeManual = "Manual";
    export const SpnClientId = "serviceprincipalid";
    export const SpnKey = "servicePrincipalKey";
    export const AuthenticationType = "authenticationType";
    export const SpnKeyAuthType = "spnKey";
    export const CertAuthType = "spnCertificate";
    export const AzureSpnCertificate = "servicePrincipalCertificate";
    export const AzureRmEndpointType = "azurerm";
    export const AzureClassicEndpointType = "azure";
    export const ContributorRoleId = "b24988ac-6180-42a0-ab88-20f7382dd24c";
    export const OwnerRoleId = "8e3af657-a8ff-443c-a75c-2fe8c4bcb635";
    export const UserAccessAdministratorRoleId = "18d7d88d-d35e-4fb5-a5c3-7773c20a72d9";
    export const AzureSpnRoleAssignmentId = "azureSpnRoleAssignmentId";
    export const AzureSpnPermissions = "azureSpnPermissions";
    export const ScopeLevel = "scopeLevel";
    export const AppToken = "AppToken";
    export const PublishProfile = "publishProfile";
    export const ResourceId = "resourceId";
    export const AppServiceProviderType = "microsoft.web/sites";
    export const ResourceGroups = "resourceGroups";
    export const Subscriptions = "subscriptions";
    export const WorkloadIdentityFederationSubject = "workloadIdentityFederationSubject";
    export const WorkloadIdentityFederationIssuer = "workloadIdentityFederationIssuer";
    export const ConvertAuthenticationSchemeOperation = "ConvertAuthenticationScheme";
    export const ConvertAuthenticationSchemeInProgressStatus = "converting_scheme";
    export const ConvertAuthenticationSchemeFailedStatus = "converting_scheme_failed";
    export const ChangePropertiesOperation = "ChangeProperties";
    export const IsDraft = "isDraft";
    export const RevertSchemeDeadline = "revertSchemeDeadline";
    export const RevertSchemeDeadlineExpired = "revertSchemeDeadlineExpired";
    export const DefaultArmUriString = "resourceManagerUrl";
    export const DefaultGraphUriString = "graphUrl";
    export const DefaultAuthorityUriString = "environmentAuthorityUrl";
    export const DefaultGraphApiVersionString = "defaultGraphApiVersion";
    export const DefaultGalleryUrlString = "galleryUrl";
    export const DefaultServiceManagementUriString = "serviceManagementUrl";
    export const DefaultActiveDirectoryAuthorityString = "activeDirectoryAuthority";
    export const DefaultArmManagementPortalUriString = "armManagementPortalUrl";
    export const DefaultAzureKeyVaultDnsSuffixString = "AzureKeyVaultDnsSuffix";
    export const DefaultAzureKeyVaultServiceEndpointResourceIdString = "AzureKeyVaultServiceEndpointResourceId";
    export const DefaultActiveDirectoryServiceEndpointResourceIdString = "ActiveDirectoryServiceEndpointResourceId";
    export const ServicePrincipalJobName = "AzureServicePrincipalEndpointJob";
    export const ServicePrincipalJobExtensionName = "Microsoft.Azure.DevOps.ServiceEndpoints.Server.Extensions.AzureServicePrincipalEndpointJob";
    export const PublishProfileJobName = "AzurePublishProfileEndpointJob";
    export const PublishProfileJobExtensionName = "Microsoft.Azure.DevOps.ServiceEndpoints.Server.Extensions.AzurePublishProfileEndpointJob";
    export const ArmUriRegistryPath = "/Service/Commerce/AzureResourceManager/BaseUrl";
    export const ArmSubscriptionsFormat = "subscriptions?api-version={0}";
    export const DynamicAppDisplayNamePrefix = "VisualStudioSPN";
    export const DynamicAppUrl = "https://VisualStudio/SPN";
    export const ArmRoleAssignmentFormat = "{0}/providers/Microsoft.Authorization/roleAssignments/{1}?api-version={2}";
    export const ArmGetRoleAssignmentFormat = "{0}/providers/Microsoft.Authorization/roleAssignments?api-version={1}&$filter=principalId eq \'{2}\'";
    export const ArmApiVersion = "2015-07-01";
    export const EnableAdfsAuthentication = "EnableAdfsAuthentication";
    export const AdfsUrlSuffix = "/adfs/";
    export const AuthorizationHeader = "Authorization";
    export const ContentTypeHeader = "Content-Type";
    export const AcceptHeader = "Accept";
    export const TransferEncodingHeader = "TransferEncoding";
    export const ContentLengthHeader = "Content-Length";
    export const ArmResourceUri = "https://management.core.windows.net/";
    export const VstsClientId = "499b84ac-1321-427f-aa17-267ca6975798";
    export const DefaultArmUri = "https://management.azure.com";
    export const DefaultGraphUri = "https://graph.windows.net/";
    export const DefaultMicrosoftGraphUri = "https://graph.microsoft.com/";
    export const DefaultMicrosoftGraphApiVersion = "v1.0";
    export const DefaultAuthorityUri = "https://login.windows.net/";
    export const MsalDefaultAuthorityUri = "https://login.microsoftonline.com/";
    export const DefaultGraphApiVersion = "1.6";
    export const PpeArmUri = "https://api-dogfood.resources.windows-int.net/";
    export const PpeGraphUri = "https://graph.ppe.windows.net/";
    export const PpeMicrosoftGraphUri = "https://graph.microsoft-ppe.com/";
    export const PpeMicrosoftGraphApiVersion = "v1.0";
    export const PpeAuthorityUri = "https://login.windows-ppe.net/";
    export const PpeGraphApiVersion = "1.5-internal";
    export const SubScriptionId = "subscriptionId";
    export const DefaultManagementGroupApiVersion = "2018-03-01-preview";
    export const DefaultListSubscriptionsApiVersion = "2019-06-01";
    export const DefaultAzureEnvironment = "AzureCloud";
    export const EnvironmentString = "environment";
    export const AzureStackString = "AzureStack";
}

export module AzurePermissionResourceProviders {
    export const AzureRoleAssignmentPermission = "Microsoft.RoleAssignment";
    export const AzureKeyVaultPermission = "Microsoft.KeyVault";
}

export module AzureRmManagementResource {
    export const LocationId = "9acb984c-4f88-4e13-9691-2e688dddc047";
    export const LocationIdString = "9acb984c-4f88-4e13-9691-2e688dddc047";
    export const Name = "azurermmanagementgroups";
}

export module AzureRmSubscriptionsResource {
    export const LocationId = "18e8f65d-4e19-4a01-a621-cf0f2d938108";
    export const LocationIdString = "18e8f65d-4e19-4a01-a621-cf0f2d938108";
    export const Name = "azurermsubscriptions";
}

export module EndpointAuthorizationSchemes {
    export const AzureStorage = "AzureStorage";
    export const ApplicationOAuth = "ApplicationOAuthToken";
    export const OAuth = "OAuth";
    export const OAuthWrap = "OAuthWrap";
    export const OAuth2 = "OAuth2";
    export const Certificate = "Certificate";
    export const UsernamePassword = "UsernamePassword";
    export const Token = "Token";
    export const PersonalAccessToken = "PersonalAccessToken";
    export const ServicePrincipal = "ServicePrincipal";
    export const WorkloadIdentityFederation = "WorkloadIdentityFederation";
    export const None = "None";
    export const Jwt = "JWT";
    export const Kubernetes = "Kubernetes";
    export const ManagedServiceIdentity = "ManagedServiceIdentity";
    export const InstallationToken = "InstallationToken";
    export const JiraConnectApp = "JiraConnectApp";
    export const PublishProfile = "PublishProfile";
}

export module EndpointProxyResource {
    export const LocationId = "cc63bb57-2a5f-4a7a-b79c-c142d308657e";
    export const LocationIdString = "CC63BB57-2A5F-4A7A-B79C-C142D308657E";
    export const Name = "endpointproxy";
}

export module EndpointResource {
    export const ProjectLocationId = "e85f1c62-adfc-4b74-b618-11a150fb195e";
    export const CollectionLocationId = "14e48fdc-2c8b-41ce-a0c3-e26f6cc55bd0";
    export const ProjectLocationIdString = "E85F1C62-ADFC-4B74-B618-11A150FB195E";
    export const CollectionLocationIdString = "14E48FDC-2C8B-41CE-A0C3-E26F6CC55BD0";
    export const Name = "endpoints";
}

export module EndpointShareResource {
    export const LocationId = "86e77201-c1f7-46c9-8672-9dfc2f6f568a";
    export const Name = "share";
}

export module EndpointTypeResource {
    export const LocationId = "5a7938a4-655e-486c-b562-b78c54a7e87b";
    export const Name = "types";
}

export module ExectionHistoryResource {
    export const GetLocationId = "10a16738-9299-4cd1-9a81-fd23ad6200d0";
    export const PostLocationId = "55b9ed4b-5404-41b1-b9d2-7ed757d02bb0";
    export const GetLocationIdString = "10A16738-9299-4CD1-9A81-FD23AD6200D0";
    export const PostLocationIdString = "55B9ED4B-5404-41B1-B9D2-7ED757D02BB0";
    export const Name = "executionhistory";
}

export module OAuthConfigurationResource {
    export const LocationId = "702edb4e-3952-43fe-a4eb-288938f3ba35";
    export const LocationIdString = "702edb4e-3952-43fe-a4eb-288938f3ba35";
    export const Name = "oauthconfiguration";
}

export module ServiceEndpointResourceIds {
    export const AreaId = "1814AB31-2F4F-4A9F-8761-F4D77DC5A5D7";
    export const AreaName = "serviceendpoint";
}

export module ServiceEndpointTypes {
    /**
    * Azure endpoint
    */
    export const Azure = "Azure";
    /**
    * Chef endpoint
    */
    export const Chef = "Chef";
    /**
    * Chef endpoint
    */
    export const ExternalTfs = "ExternalTfs";
    /**
    * Generic endpoint
    */
    export const Generic = "Generic";
    /**
    * GitHub endpoint
    */
    export const GitHub = "GitHub";
    /**
    * GitHub for Azure Boards endpoint (internal use only)
    */
    export const GitHubBoards = "GitHubBoards";
    /**
    * GitHub Enterprise for Azure Boards endpoint (internal use only)
    */
    export const GitHubEnterpriseBoards = "GitHubEnterpriseBoards";
    /**
    * GitHub Enterprise endpoint
    */
    export const GitHubEnterprise = "GitHubEnterprise";
    /**
    * Bitbucket endpoint
    */
    export const Bitbucket = "Bitbucket";
    /**
    * SSH endpoint
    */
    export const SSH = "SSH";
    /**
    * Subversion endpoint
    */
    export const Subversion = "Subversion";
    /**
    * Gcp endpoint
    */
    export const Gcp = "google-cloud";
    /**
    * Subversion endpoint
    */
    export const Jenkins = "Jenkins";
    /**
    * Jira endpoint
    */
    export const Jira = "Jira";
    /**
    * External Git repository
    */
    export const ExternalGit = "Git";
    /**
    * Azure RM endpoint
    */
    export const AzureRM = "AzureRM";
    /**
    * Azure Deployment Manager
    */
    export const AzureDeploymentManager = "AzureDeploymentManager";
    /**
    * Azure Service Fabric
    */
    export const AzureServiceFabric = "ServiceFabric";
    /**
    * Azure Service Bus
    */
    export const AzureServiceBus = "Azure Service Bus";
    /**
    * Docker Registry
    */
    export const Docker = "dockerregistry";
    /**
    * Kubernetes endpoint
    */
    export const Kubernetes = "kubernetes";
    /**
    * Kangaroo L2 test endpoint
    */
    export const Kangaroo = "kangaroo";
    /**
    * Incoming web hook endpoint
    */
    export const IncomingWebHook = "incomingwebhook";
}

export module VstsAadOAuthResource {
    export const LocationId = "47911d38-53e1-467a-8c32-d871599d5498";
    export const LocationIdString = "47911d38-53e1-467a-8c32-d871599d5498";
    export const Name = "vstsaadoauth";
}

